<template>
  <O3D>
    <slot></slot>
  </O3D>
</template>

<script>
import { O3DG2, CacheMake } from '../../../Reusable/O3DG2'
import { Mesh, Color, OctahedronBufferGeometry, MeshBasicMaterial } from 'three'

export default {
  props: {
    info: {}
  },
  mixins: [O3DG2],
  data () {
    return {
      controls: false
    }
  },
  async mounted () {
    // let boxGeo = new BoxBufferGeometry(80, 60, 80)
    // boxGeo.translate(0, 60 / 2, 0)
    // let boxMat = new MeshBasicMaterial({ color: 0xff00ff, opacity: 0.0, transparent: true })
    // let boxMesh = new Mesh(boxGeo, boxMat)
    // this.o3d.add(boxMesh)

    let colors = {
      white: new Color('#ffffff'),
      gray: new Color('#bababa'),
      green: new Color('#00bb00'),
      blue: new Color('#6565ff')
    }

    let makePlacer = () => {
      let geo = CacheMake('OctahedronBufferGeometry(30, 2)', () => {
        return new OctahedronBufferGeometry(30, 2)
      })

      // geo.rotateX(Math.PI * -0.5)
      // geo.scale(4.5, 4.5, 4.5)

      let mat = new MeshBasicMaterial({ wireframe: true, color: colors.gray })
      let mesh = new Mesh(geo, mat)

      let r1 = Math.random() - 0.5
      let r2 = Math.random() - 0.5
      let r3 = Math.random() - 0.5

      this.onLoop(() => {
        mesh.rotation.y += 0.02 * r1
        mesh.rotation.z += 0.02 * r2
        mesh.rotation.x += 0.02 * r3
      })
      return mesh
    }

    let placer = makePlacer()

    this.o3d.add(placer)
    placer.position.y = 30

    this.ctx.rayplay.add(placer, () => {
      this.$emit('clicker', this.info)
      placer.material.color = colors.gray
    })
    this.onClean(() => {
      this.ctx.rayplay.remove(placer)
    })

    this.ctx.rayplay.hover(placer, () => {
      placer.material.color = colors.blue
    }, () => {
      placer.material.color = colors.gray
    })
  }
}
</script>

<style>

</style>
